import React from 'react';
import PropTypes from 'prop-types';

import OOHStepper from './OOHStepper';
import CreateStudyContainer from '../CreateStudyContainer';

const OOHContainer = ({history}) => {
  return (
    <CreateStudyContainer>
      <OOHStepper {...{history}} />
    </CreateStudyContainer>
  );
};

OOHContainer.propTypes = {
  history: PropTypes.object,
};

export default OOHContainer;
